import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDealerOutletsBPRAllList = createAsyncThunk("fetchDealerOutletsBPRAllList", async ({ page, limit, filters }) => {
	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
		type: filters?.type ?? "",
	});

	const response = await axiosHttp.get(`dealer/module-metadata?${params}`);

	return response.data.data;
});

const DealerOutletsBPRAllListSlice = createSlice({
	name: "DealerOutletsBPRAllListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDealerOutletsBPRAllList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDealerOutletsBPRAllList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = String(action.payload.parsedPage);
			state.total = action.payload.total;
		});

		builder.addCase(fetchDealerOutletsBPRAllList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DealerOutletsBPRAllListSlice.reducer;
